import Store from "@/store/store";
import ApiClient from "@/utilities/ApiClient";
import Utils from "@/utilities/Utils";
import { mapData } from "@/utilities/DataMapping";
import { IClient, Client } from "@/model/Client";
import Colours from "@/utilities/Colours";

export interface IClientSettings {
    host: string;
    client: IClient;
}

export class ClientSettings implements IClientSettings {

    constructor(data?: IClientSettings) {
        if (data) this.update(data);
    }

    host: string = "";
    client: Client = new Client();

    isBannerDark: boolean = false;

    // get isNew() {
    //     return Utils.isEmptyId(this.id);
    // }

    update(data: IClientSettings): ClientSettings {
        const mapping = {
            root: () => this,
            client: (data: IClient) => this.client.update(data)
        };
        mapData(data, mapping);
        this.isBannerDark = Colours.isDark(this.client.bannerColour);
        return this;
    }

    reset(): void {
        Utils.resetObject(this.client);
        this.host = "";
        this.isBannerDark = false;
    }

    async checkLoaded(): Promise<void> {

        // do we have a preview override?
        const urlParams = new URLSearchParams(window.location.search);
        let clientID = urlParams.get("clientid") ?? "";

        // signed-in user's client id?
        const user = Store.state.signedInUser;
        if (user && !clientID && user.clientIDs.length === 1) clientID = user.clientIDs[0];

        // QR Code? (base32 string - should be 20 chars long)
        const slashAt = document.URL.lastIndexOf("/");
        const keyLen = slashAt === -1 ? 0 : document.URL.length - slashAt - 1;
        const qrKey = Utils.isEmptyId(clientID) && keyLen === 20
            ? document.URL.substring(document.URL.lastIndexOf("/") + 1)
            : "";

        const isClientIdOrQrCode = !Utils.isEmptyId(clientID) || qrKey !== "";

        //console.log("+++ checkLoaded - clientID = ", clientID);
        //console.log("+++ checkLoaded -  this.client.id = ", this.client.id);

        // - if no client id (from user or preview url) and already loaded, skip
        // - if client id and matches, skip
        if ((!isClientIdOrQrCode && !this.client.isNew) ||
            (isClientIdOrQrCode && !this.client.isNew && clientID === this.client.id)) {

            console.log("+++ checkLoaded - skipping");
            return;
        }

        // if no clientID, fall back to getting client from site domain
        // (note 'host' includes the port, 'hostname' does not - see also SiteList.vue)
        const data: IClientSettings = await ApiClient.get(`/api/client/settings?host=${location.hostname}&clientid=${clientID}&qrKey=${qrKey}`);
        console.log("+++ checkLoaded - data.id = ", data.client.id);
        this.update(data);
    }
}